export const PS_HEADER_LOADER = {
  desktop: `
  <div class="cui-grid">
  <div class="cui-container -spacing--top-16 -spacing--bottom-16">
    <div class="cui-row">
      <div class="cui-col-md-10">
          <div class="cui-skeleton-rectangle -is--block">
              <div class="cui-skeleton__item" style="width: 100%; height: 35px;"></div>
          </div>
      </div>
    </div>
  </div>
</div>`
};
